import {ProductInterface} from "../../interfaces/product/ProductInterface";
import BrandInfo from "./BrandInfo";
import {ProductPropertyValueInterface} from "../../interfaces/product/ProductPropertyValueInterface";
import PropertyTable from "./PropertyTable";

export default function Specification({product, properties, parentCategory}: {product:ProductInterface, properties: ProductPropertyValueInterface[], parentCategory?: any}) {
    return (<div
        className="flex-column flex-lg-row gap-4 fade justify-content-between prod-pane  active show"
    >
        <div className="d-flex flex-column prod-pane__left">
            <div className="prod-pane__text">
                <p className="fw-bold text-uppercase">Технические характеристики</p>
                <PropertyTable properties={properties} parentCategory={parentCategory} />
            </div>
        </div>
        <BrandInfo product={product} />
    </div>)
}